import React, { Component, Fragment } from "react"
import Async from "react-select"
import modalIcon from "../../../assets/images/testIcon.svg"
import Field from "../../Common/Field/Field"
import ModuleHeader from "../ModuleHeader"
import Button from "../../Buttons/Button"
import ButtonIcon from "../../Costing/Button/ButtonIcon"

const dispatchTemplate = {
  date: "",
  location: "",
  awb: "",
  courier: "",
  size: "",
  qty: ""
}

export default class DispatchModule extends Component {
  state = {
    _id: "",
    dispatch: [],
    assignedToList: [],
    STATUS: [],
    disabled: false,
    durationDispatch: null
  }

  componentWillMount() {
    const {
      _id,
      dispatch,
      dispatchProcess,
      assignedToList,
      STATUS,
      LOCATION,
      COURIER,
      disabled,
      SIZELIST,
      durationDispatch
    } = this.props
    this.setState({
      _id,
      dispatch,
      dispatchProcess,
      disabled,
      assignedToList,
      STATUS,
      LOCATION,
      COURIER,
      SIZELIST,
      durationDispatch
    })
  }

  componentWillReceiveProps(nextProps) {
    const {
      _id,
      dispatch,
      dispatchProcess,
      assignedToList,
      STATUS,
      disabled,
      LOCATION,
      COURIER,
      SIZELIST,
      durationDispatch
    } = nextProps
    this.setState({
      _id,
      dispatch,
      dispatchProcess,
      disabled,
      assignedToList,
      STATUS,
      LOCATION,
      COURIER,
      SIZELIST,
      durationDispatch
    })
  }

  render() {
    const { dispatch, assignedToList, STATUS, disabled } = this.state
    const { permissions } = this.props
    return (
      <div
        class="card-filter meeting-min-con"
        id="dispatch"
        style={{ marginBottom: ".5%" }}
      >
        <div class="col-md-12 ">
          <ModuleHeader
            header={"Dispatch "}
            durationETA={this.state.durationDispatch}
            updateModulesMain={this.props.updateModulesMain}
            moduleName={"dispatch"}
            disabled={this.state.disabled}
            process={this.state.dispatchProcess}
            onClick={this.onOpenModal}
            _id={this.state._id}
            statusList={STATUS}
            measurementModal={true}
            customer={this.props.customer}
            customerDepartmentId={this.props.customerDepartmentId}
            type={this.props.type}
            magnumStyleId = {this.props.magnumStyleId}
          />
          {/* {this.state.toggleLists.dispatch.toggle && ( */}
          <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
            <div class="wash-container">
              <form id="dispatchForm">
                <div class="col-md-12 no-padding">
                  <Fragment>
                    <div>
                      <div
                        class="col-md-12 no-padding"
                        style={{ marginBottom: " 15px" }}
                      >
                        <div class="col-md-2 step-one pl-0">
                          <Field
                            isFormGroup={true}
                            inputType="checkboxToggle"
                            inputName="magnumCounter"
                            value={dispatch.magnumCounter}
                            label="Magnum counter"
                            onChange={this.props.udpateDispatch}
                            disabled={this.state.disabled}
                          />
                        </div>
                      </div>
                      <div class="col-md-12  no-padding">
                        <table class="table">
                          <thead class="border-bottom-0">
                            <tr class="border-bottom-0">
                              <th class="border-bottom-0 text-left" width="10%">
                                Date
                              </th>
                              <th class="border-bottom-0 text-left" width="10%">
                                Location
                              </th>
                              <th class="border-bottom-0 text-left" width="10%">
                                AWB No.
                              </th>
                              <th class="border-bottom-0 text-left" width="10%">
                                Courier
                              </th>
                              <th class="border-bottom-0 text-left" width="10%">
                                Size
                              </th>
                              <th class="border-bottom-0 text-left" width="10%">
                                Qty
                              </th>
                              <th class="border-bottom-0 text-left" width="10%">
                                {permissions.create &&
                                  permissions.edit &&
                                  !this.state.disabled && (
                                    <ButtonIcon
                                      buttonType="add"
                                      addRemoveFunc={() =>
                                        this.props.addDispatchData()
                                      }
                                    />
                                  )}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {dispatch.data.length > 0 &&
                              dispatch.data.map((val, i) => (
                                <tr key={i}>
                                  <td class="border-top-0">
                                    <Field
                                      durationETA={!val.date ? -1 : null}
                                      isFormGroup={false}
                                      inputType="date"
                                      inputName="date"
                                      label="Date"
                                      value={val.date}
                                      onChange={(name, value) =>
                                        this.props.udpateDispatchValues(
                                          name,
                                          value,
                                          i
                                        )
                                      }
                                      disabled={this.state.disabled}
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <Field
                                      isFormGroup={false}
                                      inputType="select"
                                      inputName="location"
                                      value={val.location}
                                      options={this.state.LOCATION}
                                      label={"Location"}
                                      onChange={(name, value) =>
                                        this.props.udpateDispatchValues(
                                          name,
                                          value,
                                          i
                                        )
                                      }
                                      disabled={this.state.disabled}
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <Field
                                      isFormGroup={false}
                                      inputType="text"
                                      inputName="awbNumber"
                                      value={val.awbNumber}
                                      label={"AWB No."}
                                      onChange={(name, value) =>
                                        this.props.udpateDispatchValues(
                                          name,
                                          value,
                                          i
                                        )
                                      }
                                      disabled={this.state.disabled}
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <Field
                                      isFormGroup={false}
                                      inputType="select"
                                      inputName="courier"
                                      value={val.courier}
                                      options={this.state.COURIER}
                                      label={"Courier"}
                                      onChange={(name, value) =>
                                        this.props.udpateDispatchValues(
                                          name,
                                          value,
                                          i
                                        )
                                      }
                                      disabled={this.state.disabled}
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <Field
                                      isFormGroup={false}
                                      inputType="select"
                                      inputName="size"
                                      value={val.size}
                                      options={this.state.SIZELIST}
                                      label={"Size"}
                                      onChange={(name, value) =>
                                        this.props.udpateDispatchValues(
                                          name,
                                          value,
                                          i
                                        )
                                      }
                                      disabled={this.state.disabled}
                                    />
                                  </td>
                                  <td class="border-top-0">
                                    <Field
                                      isFormGroup={false}
                                      inputType="number"
                                      inputName="quantity"
                                      value={val.quantity}
                                      label={"Qty"}
                                      onChange={(name, value) =>
                                        this.props.udpateDispatchValues(
                                          name,
                                          value,
                                          i
                                        )
                                      }
                                      disabled={this.state.disabled}
                                    />
                                  </td>

                                  <td class="border-top-0">
                                    {permissions.create &&
                                      permissions.edit &&
                                      !this.state.disabled && (
                                        <ButtonIcon
                                          buttonType="clear"
                                          addRemoveFunc={() =>
                                            this.props.removeDispatchData(i)
                                          }
                                        />
                                      )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-12 step-one px-0">
                        <Field
                          isFormGroup={true}
                          inputType="textarea"
                          inputName="comments"
                          value={dispatch.comments}
                          label="Comments"
                          onChange={this.props.udpateDispatch}
                          disabled={this.state.disabled}
                        />
                      </div>
                    </div>
                  </Fragment>
                </div>
              </form>
              {/* })} */}
            </div>
            {!this.state.disabled && (permissions.create || permissions.edit) && (
              <div class="col-md-12 no-padding text-center profile-btn">
                <Button
                  buttonName={"save"}
                  onClick={e => this.props.createDispatch(e)}
                />
                <Button
                  buttonName={"Complete"}
                  onClick={e => this.props.completeDispatch(e)}
                />
              </div>
            )}
          </div>
          {/* )} */}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/DispatchModule/index.js